/**
 * 翻译上下文
 * 提供应用范围内的翻译状态和功能
 *
 * 核心功能：
 * 1. 共享翻译状态
 * 2. 提供翻译方法
 * 3. 整合翻译服务和存储
 */
import { createContext } from 'react';
/**
 * 创建翻译上下文
 * 默认值设置为undefined，必须通过Provider提供
 */
export const TranslationContext = createContext(undefined);
//# sourceMappingURL=TranslationContext.js.map